import * as React from 'react';

import { Popover, Table, Button } from 'components/bootstrap';
import { OverlayTrigger, Icon } from 'components/common';

const teamsQueryHelpPopover = (
  <Popover id="team-search-query-help" title="Search Syntax Help">
    <p><strong>Available search fields</strong></p>
    <Table condensed>
      <thead>
        <tr>
          <th>Field</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>name</td>
          <td>Team name</td>
        </tr>
        <tr>
          <td>description</td>
          <td>Description of the Team</td>
        </tr>
      </tbody>
    </Table>
    <p><strong>Examples</strong></p>
    <p>
      Find roles with a description containing security:<br />
      <code>description:security</code><br />
    </p>
  </Popover>
);

const TeamsQueryHelp = () => (
  <OverlayTrigger trigger="click" rootClose placement="right" overlay={teamsQueryHelpPopover}>
    <Button bsStyle="link"><Icon name="question-circle" /></Button>
  </OverlayTrigger>
);

export default TeamsQueryHelp;
